import { Dispatch, ThunkAction } from '../../../../types/actions';
import { IGetState } from '../../../../types/types';
import { fetchHandler } from '../../../../util/fetchHandler';
import { Util } from '../../../../util/util';
import { REST_PRODUCT } from '../../../constants';
import { getRestHeadersGet } from '../../../helpers/getRestHeadersHelper';
import { IRestProduct } from 'app/types/rest/IRestProduct';

export const getRest = (
): ThunkAction => {
    const action = (
        dispatch: Dispatch,
        getState: IGetState
    ) => {
        return fetchHandler<IRestProduct[]>(
            Util.getApiUrl(REST_PRODUCT),
            getRestHeadersGet()
        ).then(response => {
            return response
        });
    };
    return action;
};
